
import { common as koCommon } from './ko/common';
import { common as enCommon } from './en/common';
import { common as zhCommon } from './zh/common';

const resources = {
  ko: {
    common: koCommon,
  },
  en: {
    common: enCommon,
  },
  zh: {
    common: zhCommon,
  },
};

export default resources;
